(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function render(el, state) {
    if (el.hasAttribute('data-snoozy-countdown-compact')) {
      el.textContent = pad(state.hours) + ':' + pad(state.minutes) + ':' + pad(state.seconds);
      return;
    }
    var hoursEl = el.querySelector('[data-snoozy-countdown-hours]');
    var minutesEl = el.querySelector('[data-snoozy-countdown-minutes]');
    var secondsEl = el.querySelector('[data-snoozy-countdown-seconds]');
    if (hoursEl) hoursEl.textContent = pad(state.hours);
    if (minutesEl) minutesEl.textContent = pad(state.minutes);
    if (secondsEl) secondsEl.textContent = pad(state.seconds);
  }

  function init(el) {
    var state = {
      hours: parseInt(el.getAttribute('data-snoozy-countdown-hours-start'), 10) || 5,
      minutes: parseInt(el.getAttribute('data-snoozy-countdown-minutes-start'), 10) || 56,
      seconds: parseInt(el.getAttribute('data-snoozy-countdown-seconds-start'), 10) || 27
    };

    render(el, state);

    setInterval(function () {
      if (state.seconds > 0) {
        state.seconds--;
      } else if (state.minutes > 0) {
        state.minutes--;
        state.seconds = 59;
      } else if (state.hours > 0) {
        state.hours--;
        state.minutes = 59;
        state.seconds = 59;
      }
      render(el, state);
    }, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-snoozy-countdown]').forEach(init);
  });
})();
